function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, ContextActions, GLOBAL_SHORTCUTS, Tooltip } from '@deephaven/components';
import { LayoutUtils } from '@deephaven/dashboard';
import Log from '@deephaven/log';
import { vsGripper } from '@deephaven/icons';
import { Type as FilterType } from '@deephaven/filters';
import clamp from 'lodash.clamp';
import { isLinkableFromPanel } from "./LinkerUtils.js";
import LinkerLink from "./LinkerLink.js";
import "./LinkerOverlayContent.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('LinkerOverlayContent');
export class LinkerOverlayContent extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "dialogRef", void 0);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleEscapePressed = this.handleEscapePressed.bind(this);
    this.handleOperatorChanged = this.handleOperatorChanged.bind(this);
    this.dialogRef = /*#__PURE__*/React.createRef();
    this.state = {
      mouse: undefined,
      dialog: undefined,
      offset: {
        x: 0,
        y: 0
      },
      isDragging: false,
      mode: 'select'
    };
  }
  componentDidMount() {
    window.addEventListener('blur', this.handleBlur, true);
    window.addEventListener('mousemove', this.handleMouseMove, true);
    window.addEventListener('mouseup', this.handleMouseUp, true);
    window.addEventListener('keydown', this.handleKeyDown, true);
    window.addEventListener('keyup', this.handleKeyUp, true);
    window.addEventListener('resize', this.handleResize, true);
  }

  // eslint-disable-next-line react/sort-comp
  componentDidCatch(error, info) {
    log.error('componentDidCatch', error, info);
  }
  componentWillUnmount() {
    window.removeEventListener('blur', this.handleBlur, true);
    window.removeEventListener('mousemove', this.handleMouseMove, true);
    window.removeEventListener('mouseup', this.handleMouseUp, true);
    window.removeEventListener('keydown', this.handleKeyDown, true);
    window.removeEventListener('keyup', this.handleKeyUp, true);
    window.removeEventListener('resize', this.handleResize, true);
  }
  /** Gets the on screen points for a link start or end spec */
  getPointFromLinkPoint(linkPoint) {
    var _this$props = this.props,
      panelManager = _this$props.panelManager,
      linkTargetPropMap = _this$props.linkTargetPropMap;
    var linkPointId = linkPoint.panelId,
      columnName = linkPoint.columnName;
    var panelId = linkPointId;
    var linkTargetHandlers = linkTargetPropMap.get(linkPointId);
    if (linkTargetHandlers != null) {
      panelId = linkTargetHandlers.panelId;
      var coordinates = linkTargetHandlers.getCoordinates(columnName);
      if (coordinates != null) {
        return coordinates;
      }
    }
    var panel = panelManager.getOpenedPanelById(panelId);
    if (linkTargetHandlers == null && panel != null) {
      if (!isLinkableFromPanel(panel)) {
        throw new Error("Panel does not have getCoordinateForColumn method: ".concat(panelId));
      }
      try {
        // TODO: remove try/catch when IDS-7371 is fixed.
        // getCoordinateForColumn throws an exception when accessing
        // columns on a model while it reconnects
        var coordinate = panel.getCoordinateForColumn(columnName);
        if (coordinate != null) {
          return coordinate;
        }
      } catch (e) {
        log.error('Could not get coordinate for column', columnName, panel);
      }
    }
    // Fallback to panel container if the panel itself
    // crashed, unmounted, and removed from openedPanelMap.
    var glContainer = panelManager.getContainerByPanelId(panelId);
    if (glContainer == null) {
      throw new Error("Unable to find panel container for id: ".concat(panelId));
    }
    return LayoutUtils.getTabPoint(glContainer);
  }
  handleOperatorChanged(linkId, type) {
    var _this$props2 = this.props,
      links = _this$props2.links,
      onLinksUpdated = _this$props2.onLinksUpdated;
    var newLinks = links.map(link => link.id === linkId ? _objectSpread(_objectSpread({}, link), {}, {
      operator: type
    }) : link);
    onLinksUpdated(newLinks);
  }
  handleBlur() {
    this.setState({
      mode: 'select'
    });
  }
  handleResize() {
    var dialog = this.state.dialog;
    if (dialog && this.dialogRef.current) {
      var rect = this.dialogRef.current.getBoundingClientRect();
      var dialogX = clamp(dialog.x, 0, window.innerWidth - rect.width);
      var dialogY = clamp(dialog.y, 0, window.innerHeight - rect.height);
      this.setState({
        dialog: {
          x: dialogX,
          y: dialogY
        }
      });
    }
  }
  handleMouseMove(event) {
    var _this$state = this.state,
      offset = _this$state.offset,
      isDragging = _this$state.isDragging;
    this.setState({
      mouse: {
        x: event.clientX,
        y: event.clientY
      }
    });
    if (isDragging && this.dialogRef.current) {
      var rect = this.dialogRef.current.getBoundingClientRect();
      var dialogX = clamp(window.innerWidth - (event.clientX + rect.width + offset.x), 0, window.innerWidth - rect.width);
      var dialogY = clamp(window.innerHeight - (event.clientY + rect.height + offset.y), 0, window.innerHeight - rect.height);
      this.setState({
        dialog: {
          x: dialogX,
          y: dialogY
        }
      });
    }
  }
  handleMouseDown(event) {
    event.preventDefault();
    var offset = {
      x: 0,
      y: 0
    };
    if (this.dialogRef.current) {
      var rect = this.dialogRef.current.getBoundingClientRect();
      offset.x = rect.right - (rect.width + event.clientX);
      offset.y = rect.bottom - (rect.height + event.clientY);
    }
    this.setState({
      isDragging: true,
      offset
    });
  }
  handleMouseUp() {
    this.setState({
      isDragging: false
    });
  }
  handleKeyDown(event) {
    if (event.key === 'Alt') {
      event.preventDefault();
      this.setState({
        mode: 'delete'
      });
    } else if (event.key === 'Delete' || event.key === 'Backspace') {
      var _this$props3 = this.props,
        selectedIds = _this$props3.selectedIds,
        onLinkDeleted = _this$props3.onLinkDeleted;
      event.preventDefault();
      selectedIds.forEach(id => onLinkDeleted(id));
    }
  }
  handleKeyUp(event) {
    if (event.key === 'Alt') {
      event.preventDefault();
      this.setState({
        mode: 'select'
      });
    }
  }
  handleEscapePressed() {
    var onCancel = this.props.onCancel;
    onCancel();
  }
  render() {
    var _this$props4 = this.props,
      disabled = _this$props4.disabled,
      links = _this$props4.links,
      selectedIds = _this$props4.selectedIds,
      messageText = _this$props4.messageText,
      onLinkSelected = _this$props4.onLinkSelected,
      onLinkDeleted = _this$props4.onLinkDeleted,
      onAllLinksDeleted = _this$props4.onAllLinksDeleted,
      onDone = _this$props4.onDone;
    var _this$state2 = this.state,
      mouse = _this$state2.mouse,
      dialog = _this$state2.dialog,
      isDragging = _this$state2.isDragging,
      mode = _this$state2.mode;
    var visibleLinks = links.map(link => {
      try {
        var _mouse$x, _mouse$y;
        var id = link.id,
          type = link.type,
          isReversed = link.isReversed,
          start = link.start,
          end = link.end,
          operator = link.operator;
        var startColumnType = start.columnType;
        var _this$getPointFromLin = this.getPointFromLinkPoint(start),
          _this$getPointFromLin2 = _slicedToArray(_this$getPointFromLin, 2),
          x1 = _this$getPointFromLin2[0],
          y1 = _this$getPointFromLin2[1];
        var x2 = (_mouse$x = mouse === null || mouse === void 0 ? void 0 : mouse.x) !== null && _mouse$x !== void 0 ? _mouse$x : x1;
        var y2 = (_mouse$y = mouse === null || mouse === void 0 ? void 0 : mouse.y) !== null && _mouse$y !== void 0 ? _mouse$y : y1;
        if (end != null) {
          var _this$getPointFromLin3 = this.getPointFromLinkPoint(end);
          var _this$getPointFromLin4 = _slicedToArray(_this$getPointFromLin3, 2);
          x2 = _this$getPointFromLin4[0];
          y2 = _this$getPointFromLin4[1];
        }
        if (isReversed != null && isReversed) {
          var tmpX = x1,
            tmpY = y1;
          x1 = x2;
          y1 = y2;
          x2 = tmpX;
          y2 = tmpY;
        }
        var className = classNames('linker-link', {
          disabled
        }, {
          'link-filter-source': type === 'filterSource'
        }, {
          'link-invalid': type === 'invalid'
        }, {
          interactive: link.end == null
        }, {
          'link-is-selected': selectedIds.has(id)
        }, {
          'danger-delete': mode === 'delete'
        });
        return {
          x1,
          y1,
          x2,
          y2,
          id,
          className,
          operator,
          startColumnType,
          type
        };
      } catch (error) {
        log.warn('Unable to get point for link', link, error);
        return null;
      }
    }).filter(item => item != null);
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('linker-overlay', {
        'danger-delete': mode === 'delete'
      }),
      children: [visibleLinks.map(_ref => {
        var x1 = _ref.x1,
          y1 = _ref.y1,
          x2 = _ref.x2,
          y2 = _ref.y2,
          id = _ref.id,
          className = _ref.className,
          operator = _ref.operator,
          startColumnType = _ref.startColumnType,
          type = _ref.type;
        return /*#__PURE__*/_jsx(LinkerLink, {
          className: className,
          id: id,
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          onClick: onLinkSelected,
          onDelete: onLinkDeleted,
          isSelected: selectedIds.has(id),
          operator: operator !== null && operator !== void 0 ? operator : FilterType.eq,
          startColumnType: startColumnType,
          type: type,
          onOperatorChanged: this.handleOperatorChanged
        }, id);
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames('linker-toast-dialog', {
          dragging: isDragging
        }),
        ref: this.dialogRef,
        style: {
          bottom: dialog === null || dialog === void 0 ? void 0 : dialog.y,
          right: dialog === null || dialog === void 0 ? void 0 : dialog.x
        },
        "data-testid": "linker-toast-dialog",
        children: [/*#__PURE__*/_jsx(Button, {
          draggable: true,
          kind: "inline",
          className: "btn-drag-handle",
          icon: vsGripper,
          onClick: () => {
            // no-op
          },
          onMouseDown: this.handleMouseDown,
          children: !isDragging && /*#__PURE__*/_jsx(Tooltip, {
            children: "Drag to reposition"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "toast-body",
          children: messageText
        }), /*#__PURE__*/_jsxs("div", {
          className: "toast-footer",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "secondary",
            onClick: onAllLinksDeleted,
            children: "Clear All"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "primary",
            onClick: onDone,
            children: "Done"
          })]
        })]
      }), /*#__PURE__*/_jsx(ContextActions, {
        actions: [{
          action: this.handleEscapePressed,
          shortcut: GLOBAL_SHORTCUTS.LINKER_CLOSE,
          isGlobal: true
        }]
      })]
    });
  }
}
_defineProperty(LinkerOverlayContent, "defaultProps", {
  disabled: 'false'
});
export default LinkerOverlayContent;
//# sourceMappingURL=LinkerOverlayContent.js.map